export const menuItems = [
  { name: '', label: 'Home' },
  { name: 'rentals', label: 'Properties' },
  { name: 'services', label: 'Services' },
  { name: 'contact', label: 'Contact' },
  { name: 'about', label: 'About Us' },
  { name: 'blog', label: 'Blog' },
]
